import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getRoleBasedOnUser, useAuth } from 'utils/AuthProvider';
import { HomeLinkRoutes } from 'constants/routes';
import { Role } from 'model/account';
import { useUser } from 'hooks/useAccount';

export const RedirectToRoleHomePage = ({ role }: { role?: Role }) => {
  const { token } = useAuth();
  const { user, isLoading } = useUser(token);
  if (role) {
    switch (role) {
      case Role.DOCTOR:
      case Role.PHARMACIST:
        return <Navigate to={HomeLinkRoutes.medicalAppointments} />;
      default:
        return <Navigate to={HomeLinkRoutes.patientMedical} />;
    }
  }
  if (isLoading || !user) return null;
  const userRole = getRoleBasedOnUser(user);
  return <RedirectToRoleHomePage role={userRole} />;
};

export const AuthorizedRoute = ({
  pagePermissionRole,
}: {
  pagePermissionRole?: Role[];
}) => {
  const { token, role } = useAuth();
  // we check if the user is not logged in, we redirect to login page
  if (!token) return <Navigate to={HomeLinkRoutes.login} />;
  if (pagePermissionRole && pagePermissionRole.length > 0) {
    // we check if the user has the role to access the page
    if (!pagePermissionRole.includes(role as Role)) {
      // user trying to access a page that he is not authorized to, redirect to his home page
      return <RedirectToRoleHomePage role={role as Role} />;
    }
  }
  return <Outlet />;
};

export default AuthorizedRoute;
